
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { TranslocoModule } from '@jsverse/transloco';

@Component({
  selector: 'cat-result-settings',
  templateUrl: './result-settings.component.html',
  styleUrls: ['./result-settings.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [MatSlideToggleModule, TranslocoModule]
})
export class ResultSettingsComponent {
  @Input() tabsLocked: boolean;

  @Output() tabsLockedChange: EventEmitter<boolean> = new EventEmitter<boolean>();
}
